(function () {
  'use strict';

  function initPaelluxeFinder(section) {
    if (
      !section ||
      section.dataset.paelluxeFinderInitialized === 'true'
    ) {
      return;
    }

    section.dataset.paelluxeFinderInitialized = 'true';

    const form = section.querySelector('[data-finder-form]');
    const steps = Array.from(section.querySelectorAll('[data-step]'));

    const previousButton = section.querySelector('[data-previous]');
    const restartButton = section.querySelector('[data-restart]');

    const progressWrapper = section.querySelector(
      '[data-progress-wrapper]'
    );

    const progressLabel = section.querySelector(
      '[data-progress-label]'
    );

    const progressPercent = section.querySelector(
      '[data-progress-percent]'
    );

    const progressBar = section.querySelector(
      '[data-progress-bar]'
    );

    const progressElement = section.querySelector(
      '.paelluxe-finder__progress'
    );

    const header = section.querySelector('[data-finder-header]');

    const resultScreen = section.querySelector(
      '[data-result-screen]'
    );

    const resultTitle = section.querySelector(
      '[data-result-title]'
    );

    const resultDescription = section.querySelector(
      '[data-result-description]'
    );

    const resultMeta = section.querySelector(
      '[data-result-meta]'
    );

    const resultButton = section.querySelector(
      '[data-result-button]'
    );

    const resultLink = section.querySelector(
      '[data-result-link]'
    );

    const resultImage = section.querySelector(
      '[data-result-image]'
    );

    if (!form || !steps.length) {
      return;
    }

    const COOKIE_NAME = 'paelluxe_product_finder';
    const COOKIE_HOURS = 24;

    let currentStep = 'start';
    let history = [];
    let isTransitioning = false;

    let answers = {
      cooking: '',
      size: '',
      productType: '',
      comalStyle: '',
      everythingStyle: ''
    };


    /*
     * --------------------------------------------------
     * COOKIE HELPERS
     * --------------------------------------------------
     */

    function encodeCookieValue(value) {
      try {
        const bytes = new TextEncoder().encode(value);
        let binary = '';

        bytes.forEach(function (byte) {
          binary += String.fromCharCode(byte);
        });

        return window.btoa(binary);
      } catch (error) {
        return encodeURIComponent(value);
      }
    }


    function decodeCookieValue(value) {
      try {
        const binary = window.atob(value);
        const bytes = new Uint8Array(binary.length);

        for (let index = 0; index < binary.length; index += 1) {
          bytes[index] = binary.charCodeAt(index);
        }

        return new TextDecoder().decode(bytes);
      } catch (error) {
        return decodeURIComponent(value);
      }
    }


    function setCookie(name, value, hours) {
      const expires = new Date();

      expires.setTime(
        expires.getTime() + hours * 60 * 60 * 1000
      );

      let cookie =
        encodeURIComponent(name) +
        '=' +
        encodeCookieValue(value) +
        '; expires=' +
        expires.toUTCString() +
        '; path=/' +
        '; SameSite=Lax';

      if (window.location.protocol === 'https:') {
        cookie += '; Secure';
      }

      document.cookie = cookie;
    }


    function getCookie(name) {
      const cookieName = encodeURIComponent(name) + '=';
      const cookies = document.cookie.split(';');

      for (let index = 0; index < cookies.length; index += 1) {
        const cookie = cookies[index].trim();

        if (cookie.indexOf(cookieName) === 0) {
          return decodeCookieValue(
            cookie.substring(cookieName.length)
          );
        }
      }

      return null;
    }


    function deleteCookie(name) {
      let cookie =
        encodeURIComponent(name) +
        '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
        '; path=/' +
        '; SameSite=Lax';

      if (window.location.protocol === 'https:') {
        cookie += '; Secure';
      }

      document.cookie = cookie;
    }


    /*
     * --------------------------------------------------
     * UI HELPERS
     * --------------------------------------------------
     */

    function getStep(stepId) {
      return section.querySelector(
        '[data-step="' + stepId + '"]'
      );
    }


    function scrollToFinder() {
      const offset = 100;

      const targetTop =
        section.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: 'smooth'
      });
    }


    function getProgressData() {
      if (currentStep === 'start') {
        return {
          step: 1,
          total: 3,
          percentage: 33
        };
      }

      if (
        currentStep === 'paella-size' ||
        currentStep === 'comal-style' ||
        currentStep === 'everything-style'
      ) {
        return {
          step: 2,
          total: 3,
          percentage: 67
        };
      }

      return {
        step: 3,
        total: 3,
        percentage: 100
      };
    }


    function updateProgress() {
      const progress = getProgressData();

      if (progressLabel) {
        progressLabel.textContent =
          'Step ' +
          progress.step +
          ' of ' +
          progress.total;
      }

      if (progressPercent) {
        progressPercent.textContent =
          progress.percentage + '%';
      }

      if (progressBar) {
        progressBar.style.width =
          progress.percentage + '%';
      }

      if (progressElement) {
        progressElement.setAttribute(
          'aria-valuenow',
          String(progress.percentage)
        );
      }

      if (previousButton) {
        previousButton.hidden = history.length === 0;
      }
    }


    function clearActiveChoices() {
      section
        .querySelectorAll('.paelluxe-finder__answer.is-selected')
        .forEach(function (button) {
          button.classList.remove('is-selected');
        });
    }


    function showStep(stepId, shouldScroll) {
      const target = getStep(stepId);

      if (!target) {
        return;
      }

      if (resultScreen) {
        resultScreen.hidden = true;
        resultScreen.classList.remove('is-visible');
      }

      if (header) {
        header.hidden = false;
      }

      if (progressWrapper) {
        progressWrapper.hidden = false;
      }

      form.classList.remove('is-complete');

      steps.forEach(function (step) {
        step.hidden = true;
        step.classList.remove('is-active');
      });

      currentStep = stepId;

      target.hidden = false;

      window.requestAnimationFrame(function () {
        target.classList.add('is-active');
      });

      updateProgress();

      if (shouldScroll !== false) {
        scrollToFinder();
      }
    }


    /*
     * --------------------------------------------------
     * PRODUCT DATA
     * --------------------------------------------------
     */

    function getProduct(productKey) {
      const productElement = section.querySelector(
        '[data-finder-product="' + productKey + '"]'
      );

      if (!productElement) {
        return null;
      }

      return {
        key: productKey,
        title: productElement.dataset.title || '',
        url: productElement.dataset.url || '#',
        image: productElement.dataset.image || '',
        description:
          productElement.dataset.description || '',
        meta: productElement.dataset.meta || ''
      };
    }


    function determinePaellaResult() {
      if (!answers.size || !answers.productType) {
        return null;
      }

      return (
        answers.size +
        '-' +
        answers.productType
      );
    }


    /*
     * --------------------------------------------------
     * RESULT SCREEN
     * --------------------------------------------------
     */

    function displayResult(productKey, shouldScroll) {
      const product = getProduct(productKey);

      if (!product) {
        console.error(
          'Paelluxe Product Finder: product not found:',
          productKey
        );

        return;
      }

      steps.forEach(function (step) {
        step.hidden = true;
        step.classList.remove('is-active');
      });

      if (header) {
        header.hidden = true;
      }

      if (progressWrapper) {
        progressWrapper.hidden = true;
      }

      if (previousButton) {
        previousButton.hidden = true;
      }

      if (resultTitle) {
        resultTitle.textContent = product.title;
      }

      if (resultDescription) {
        resultDescription.textContent =
          product.description;
      }

      if (resultMeta) {
        resultMeta.textContent = product.meta;
      }

      if (resultButton) {
        resultButton.href = product.url;

        if (productKey.indexOf('set') !== -1) {
          resultButton.textContent = 'Shop This Set';
        } else {
          resultButton.textContent = 'Shop Your Match';
        }
      }

      if (resultLink) {
        resultLink.href = product.url;
      }

      if (resultImage) {
        if (product.image) {
          resultImage.src = product.image;
        } else {
          resultImage.removeAttribute('src');
        }

        resultImage.alt = product.title;
      }

      if (resultScreen) {
        resultScreen.hidden = false;
      }

      form.classList.add('is-complete');

      window.requestAnimationFrame(function () {
        if (resultScreen) {
          resultScreen.classList.add('is-visible');
        }
      });

      storeState(true, productKey);

      if (shouldScroll !== false) {
        scrollToFinder();
      }
    }


    /*
     * --------------------------------------------------
     * STATE
     * --------------------------------------------------
     */

    function storeState(completed, resultKey) {
      try {
        const payload = {
          s: 'paelluxe-finder',
          u: Date.now(),
          c: Boolean(completed),
          step: currentStep,
          history: history,
          answers: answers,
          result: resultKey || ''
        };

        setCookie(
          COOKIE_NAME,
          JSON.stringify(payload),
          COOKIE_HOURS
        );
      } catch (error) {
        console.warn(
          'Paelluxe Product Finder state could not be saved.',
          error
        );
      }
    }


    function restoreState() {
      const storedCookie = getCookie(COOKIE_NAME);

      if (!storedCookie) {
        return false;
      }

      try {
        const data = JSON.parse(storedCookie);

        if (
          !data ||
          data.s !== 'paelluxe-finder'
        ) {
          deleteCookie(COOKIE_NAME);
          return false;
        }

        const storedTime = Number(data.u);
        const maxAge =
          COOKIE_HOURS * 60 * 60 * 1000;

        if (
          !storedTime ||
          Date.now() - storedTime > maxAge
        ) {
          deleteCookie(COOKIE_NAME);
          return false;
        }

        if (
          data.answers &&
          typeof data.answers === 'object'
        ) {
          answers = Object.assign(
            {},
            answers,
            data.answers
          );
        }

        if (Array.isArray(data.history)) {
          history = data.history.filter(function (step) {
            return Boolean(getStep(step));
          });
        }

        if (
          data.c === true &&
          data.result
        ) {
          displayResult(data.result, false);
          return true;
        }

        if (
          data.step &&
          getStep(data.step)
        ) {
          showStep(data.step, false);
          return true;
        }

        return false;
      } catch (error) {
        deleteCookie(COOKIE_NAME);

        return false;
      }
    }


    /*
     * --------------------------------------------------
     * ANSWER LOGIC
     * --------------------------------------------------
     */

    function saveAnswer(stepId, value) {
      switch (stepId) {
        case 'start':
          answers.cooking = value;
          break;

        case 'paella-size':
          answers.size = value;
          break;

        case 'paella-type':
          answers.productType = value;
          break;

        case 'comal-style':
        case 'comal-detail':
          answers.comalStyle = value;
          break;

        case 'everything-style':
          answers.everythingStyle = value;
          break;
      }
    }


    function goToStep(nextStep) {
      if (
        isTransitioning ||
        !getStep(nextStep)
      ) {
        return;
      }

      isTransitioning = true;

      history.push(currentStep);

      storeState(false, '');

      window.setTimeout(function () {
        showStep(nextStep, true);

        storeState(false, '');

        window.setTimeout(function () {
          isTransitioning = false;
        }, 250);
      }, 120);
    }


    function handleChoice(button) {
      if (isTransitioning) {
        return;
      }

      const step = button.closest('[data-step]');

      if (!step) {
        return;
      }

      const stepId = step.dataset.step;
      const value = button.dataset.value || '';

      step
        .querySelectorAll('[data-choice]')
        .forEach(function (choice) {
          choice.classList.remove('is-selected');
        });

      button.classList.add('is-selected');

      saveAnswer(stepId, value);


      /*
       * "Cooking for a crowd" skips size question,
       * because size is already known to be large.
       */
      if (button.dataset.presetSize) {
        answers.size = button.dataset.presetSize;
      }


      /*
       * Direct result.
       */
      if (button.dataset.result) {
        const resultKey = button.dataset.result;

        history.push(currentStep);

        window.setTimeout(function () {
          displayResult(resultKey, true);
        }, 160);

        return;
      }


      /*
       * Paella result needs size + pan/set combination.
       */
      if (button.dataset.finish === 'paella') {
        const resultKey = determinePaellaResult();

        if (!resultKey) {
          console.error(
            'Paelluxe Product Finder: incomplete Paella answer.'
          );

          return;
        }

        history.push(currentStep);

        window.setTimeout(function () {
          displayResult(resultKey, true);
        }, 160);

        return;
      }


      if (button.dataset.next) {
        goToStep(button.dataset.next);
      }
    }


    /*
     * --------------------------------------------------
     * BACK
     * --------------------------------------------------
     */

    function goBack() {
      if (
        !history.length ||
        isTransitioning
      ) {
        return;
      }

      const previousStep = history.pop();

      /*
       * If going back from Paella type, clear the type.
       */
      if (currentStep === 'paella-type') {
        answers.productType = '';
      }

      if (currentStep === 'comal-detail') {
        answers.comalStyle = '';
      }

      showStep(previousStep, true);

      storeState(false, '');
    }


    /*
     * --------------------------------------------------
     * RESET
     * --------------------------------------------------
     */

    function resetFinder() {
      deleteCookie(COOKIE_NAME);

      answers = {
        cooking: '',
        size: '',
        productType: '',
        comalStyle: '',
        everythingStyle: ''
      };

      history = [];
      currentStep = 'start';
      isTransitioning = false;

      clearActiveChoices();

      if (resultScreen) {
        resultScreen.hidden = true;
        resultScreen.classList.remove('is-visible');
      }

      if (resultTitle) {
        resultTitle.textContent = '';
      }

      if (resultDescription) {
        resultDescription.textContent = '';
      }

      if (resultMeta) {
        resultMeta.textContent = '';
      }

      if (resultImage) {
        resultImage.removeAttribute('src');
        resultImage.alt = '';
      }

      if (resultLink) {
        resultLink.href = '#';
      }

      if (resultButton) {
        resultButton.href = '#';
      }

      showStep('start', true);
    }


    /*
     * --------------------------------------------------
     * EVENTS
     * --------------------------------------------------
     */

    section
      .querySelectorAll('[data-choice]')
      .forEach(function (button) {
        button.addEventListener(
          'click',
          function () {
            handleChoice(button);
          }
        );
      });


    if (previousButton) {
      previousButton.addEventListener(
        'click',
        goBack
      );
    }


    if (restartButton) {
      restartButton.addEventListener(
        'click',
        resetFinder
      );
    }


    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
      }
    );


    /*
     * --------------------------------------------------
     * INITIAL STATE
     * --------------------------------------------------
     */

    const restored = restoreState();

    if (!restored) {
      showStep('start', false);
    }
  }


  function initAllPaelluxeFinders(scope) {
    const currentScope = scope || document;

    if (
      currentScope.matches &&
      currentScope.matches('[data-paelluxe-finder]')
    ) {
      initPaelluxeFinder(currentScope);
    }

    currentScope
      .querySelectorAll('[data-paelluxe-finder]')
      .forEach(function (section) {
        initPaelluxeFinder(section);
      });
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAllPaelluxeFinders(document);
      }
    );
  } else {
    initAllPaelluxeFinders(document);
  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAllPaelluxeFinders(event.target);
    }
  );
})();